// i18n.js
import { createI18n } from 'vue-i18n'
import { lang } from '@/util/base'

// 导入语言文件
import enLocale from '../../lang/en'
import idLocale from '../../lang/id'
import thLocale from '../../lang/th'
import vnLocale from '../../lang/vn'
import cnLocale from '../../lang/cn'

// 导入功能语言文件
// 预约
import enReserve from './lang/yy/en'
import idReserve from './lang/yy/id'
import thReserve from './lang/yy/th'
import vnReserve from './lang/yy/vn'
import cnReserve from './lang/yy/cn'

// 预约
import enHome from './lang/gw/en'
import idHome from './lang/gw/id'
import thHome from './lang/gw/th'
import vnHome from './lang/gw/vn'
import cnHome from './lang/gw/cn'
const i18n = createI18n({
  locale: lang(), // 默认语言
  messages: {
    en: {
      ...enLocale,
      reserve: enReserve,
      home: enHome
    },
    id: {
      ...idLocale,
      reserve: idReserve,
      home: idHome
    },
    th: {
      ...thLocale,
      reserve: thReserve,
      home: thHome
    },
    vn: {
      ...vnLocale,
      reserve: vnReserve,
      home: vnHome
    },
    cn: {
      ...cnLocale,
      reserve: cnReserve,
      home: cnHome
    }
  },
  allowComposition: true, // you need to specify that!
  legacy: false, // 如果要支持compositionAPI，此项必须设置为false;
  globalInjection: true // 全局注册$t方法
})

export default i18n
